import React from "react";
import { Mui } from "../../libraries/material";

const Nutrition = Mui.createSvgIcon(
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g
      id="Artboard"
      transform="translate(-608.000000, -41.000000)"
      fillRule="nonzero"
    >
      <g id="nutrition" transform="translate(608.000000, 41.000000)">
        <path
          d="M8.92235608,0.938095426 C10.5319266,0.938095426 11.8367526,2.24289386 11.8367526,3.85249193 L11.8354284,5.74300001 C11.5923667,5.81505509 11.349967,5.86010332 11.1120638,5.86010332 C10.9918157,5.86010332 10.8726158,5.84859988 10.7542987,5.82782749 L10.7573332,3.85249193 C10.7573332,3.3457615 10.5519541,2.88700343 10.2198994,2.55494866 C9.88781699,2.2228663 9.42908651,2.01748724 8.92235608,2.01748724 L8.70646668,2.01748724 C8.40839808,2.01748724 8.16677078,1.77585994 8.16677078,1.47779133 C8.16677078,1.17972272 8.40839808,0.938095426 8.70646668,0.938095426 L8.92235608,0.938095426 Z"
          id="Path"
          fill="currentColor"
          fillOpacity="0.3"
        ></path>
        <path
          d="M13.5436747,3.86206433 C13.5436747,3.86206433 13.3314542,0.0848826568 16.8115604,0 C16.8115604,0 17.0237808,3.73475414 13.5436747,3.86206433 Z"
          id="Path"
          fill="currentColor"
          fillOpacity="0.6"
        ></path>
        <path
          d="M15.6700721,4.70912539 C20.4443285,5.18060068 22.3003538,9.62034708 21.4650997,14.5828239 C20.6298455,19.5453007 17.1341531,24.0130835 15.0714522,24 C14.4670943,23.9958603 13.8895225,23.8125894 13.3094129,23.6026807 L12.897441,23.4514532 C12.2248625,23.2045625 11.5397598,22.9702428 10.7971952,22.9830676 L10.7818573,22.9815779 L10.7664642,22.98304 C10.1170029,22.9717242 9.51187261,23.1528219 8.92048022,23.3651913 L8.68459085,23.4514257 L8.39951533,23.5573235 C7.78288158,23.7854722 7.17146163,23.995566 6.52964171,24 C4.48495451,24.0130537 1.01985521,19.5452731 0.191883794,14.5827963 C-0.63606004,9.62031949 1.20374465,5.18060068 5.93623552,4.70912539 C6.80384828,4.62267032 7.64470244,4.83751144 8.39413602,5.09003527 L8.60572198,5.16297312 L9.30227287,5.41469695 L9.48732092,5.47993825 C9.85074117,5.60545534 10.1732787,5.69814489 10.4428508,5.70887591 L10.5091128,5.70981384 C10.600092,5.70868281 10.7061884,5.7216759 10.8250848,5.74603449 C10.9029882,5.72170348 10.9801191,5.70887591 11.0568363,5.70981384 C11.3197877,5.71309659 11.6371942,5.63031049 11.9968627,5.51061408 L12.1801453,5.44791071 L12.3701588,5.38043493 L12.8722824,5.19977307 C12.9069582,5.18749723 12.9418823,5.17522138 12.9770271,5.16297312 L13.1904889,5.09003527 C13.9465432,4.83751144 14.7947904,4.62267032 15.6700721,4.70912539 Z"
          id="Path"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </g>,
  "nutrition"
);

export default Nutrition;
